import {
	getAllLogs,
  postLogs,
	getServices,
	updateMessages,
	getFilterLogs,
	getFilterLogsPush,
  logsPushApp,
  getLogsPushAppDetails,
  logsFilterPushApp
} from '@/api/Erp'

export default {
	async allLogs (current_page, page_size, token) {
		try {
			const response = await getAllLogs.get({
				uriParams: {
          current_page,
          page_size
        },
				headers: {
          'Authorization': `Bearer ${token}`
        }
			})
			return response.data
		} catch (error) {
      return error.response
    }
	},
	async allFilterLogs (current_page, page_size, filter, token) {
		try {
			const response = await getFilterLogsPush.get({
				uriParams: {
          current_page,
          page_size,
          filter
        },
				headers: {
          'Authorization': `Bearer ${token}`
        }
			})
			return response.data
		} catch (error) {
      return error.response
    }
	},
	async allLogsPushApp (current_page, page_size, token) {
		try {
			const response = await logsPushApp.get({
				uriParams: {
          current_page,
          page_size
        },
				headers: {
          'Authorization': `Bearer ${token}`
        }
			})

			return response
		} catch (error) {
      return error.response
    }
	},
  async getLogsDetails(idUser, token) {
    try {
      const response = await getLogsPushAppDetails.get({
        uriParams: {
          idUser
        },
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      return response
    } catch (error) {
      return error.response
    }
  },
  async postDuplicateLogs(payload, token) {
    try {
      const response = await postLogs.post(
        payload,
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      )
      return response
    } catch (error) {
      return error.response
    }
  },
	async filterLogsPushApp(current_page, page_size, filter, token) {
    try {
      const response = await logsFilterPushApp.get({
        uriParams: {
          current_page,
          page_size,
          filter,
        },
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      return response
    } catch (error) {
      return error.response
    }
  },
	async getServices (token) {
		try {
			const response = await getServices.get({
				headers: {
          'Authorization': `Bearer ${token}`
        }
			})
			return response
		} catch (error) {
      return error.response
    }
	},
	async updateMessages(payload, token) {
    try {
      const response = await updateMessages.patch(
        {
          channelType: payload.channelType,
					dateAdded: payload.dateAdded,
					list: payload.list,
					message: payload.message,
					messageType: payload.messageType,
					moeCampaignName: payload.moeCampaignName,
					name: payload.name,
					produtoSlug: payload.produtoSlug,
					pushType: payload.pushType,
					sendTime: payload.sendTime,
					smsContent: payload.smsContent,
					title: payload.title,
					url: payload.url
        },
        {
          uriParams: {
            id: payload.name
          },
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      )
      return response
    } catch (error) {
      return error.response
    }
  },
}


// WEBPACK FOOTER //
// ./src/store/modules/logs/resources.js